<template>
  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    errorColor="rgba(var(--vs-danger), 1)"
    :title="null"
    :subtitle="null"
    finishButtonText="Submit"
  >
    <tab-content title="Step 1" class="mb-5" :before-change="validateStep1">
      <!-- tab 1 content -->
      <form data-vv-scope="step-1">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <div class="demo-alignment">
              <span>Form Type</span>
              <vs-radio v-model="radios1" vs-value="1">Poll</vs-radio><vx-tooltip text="Gather data about questions usually limited to 1-3 using polls to make it easy for users to answer them by mapping to Sessions." position="top"><span class="ml-2 info-ico">i</span></vx-tooltip>
              <vs-radio v-model="radios1" vs-value="2">Survey</vs-radio><vx-tooltip text="Use this to present set of questions to find out peoples' opinions and ideas,trends to draw a bigger picture." position="top"><span class="ml-2 info-ico">i</span></vx-tooltip>
              <vs-radio v-model="radios1" vs-value="3">Form</vs-radio><vx-tooltip text="Use it for gathering just about any type of data through a set of questions for a specific purpose." position="top"><span class="ml-2 info-ico">i</span></vx-tooltip>
              <span class="text-danger"></span>
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5">
            <vs-input
              label="Name"
              v-model="FormName"
              class="w-full"
              name="form_name"
              v-validate="'required|alpha'"
            />

            
          </div>
          
          <div class="vx-col w-full mt-5">
            <!--<vs-select v-model="Session" class="w-full select-large" label="Session">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in sessionOptions"
                class="w-full"
              />
            </vs-select>-->
            <v-select multiple :closeOnSelect="false" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <v-select :options="['Event','Session']" :value="['Event']" class="mt-5"></v-select>
          </div>
        </div>
      </form>
    </tab-content>

    <!-- tab 2 content -->
    <tab-content title="Step 2" class="mb-5" :before-change="validateStep2">
      <form data-vv-scope="step-2">
        <div class="vx-row">
            <div class="vx-col w-full button-wrap">
              <vs-button color="rgb(76, 139, 246)" type="filled" @click="popupActive=true">Preview</vs-button>
              <vs-popup class="holamundo" title="Form Preview" :active.sync="popupActive">
                <!-- form rendering -->
                  <div class="q-pa-md q-form-container">
                    <h4>Form Preview</h4>
                    <div v-for="(field, index) in fields" :key="index">
                      <component
                        v-model="fieldData[field.cid]"
                        @input="onInput"
                        v-bind:is="getElement(field)"
                        :label="field.label"
                        :required="field.required"
                        :field_options="field.field_options"
                        :id="field.cid"
                        :cid="field.cid"
                        :ref="field.cid"
                        debounce="500"
                      />
                    </div>
                  </div>
              </vs-popup>
            </div>
          <div class="w-full">
            <q-form-builder v-model="fields" :source-fields="mySourceFields" />
          </div>
        </div>
        <div class="vx-row">
          <div class="w-full">
            <q-separator />
          </div>
        </div>
      </form>
    </tab-content>

    <!-- tab 3 content -->
    <tab-content title="Step 3" class="mb-5" :before-change="validateStep3">
      <form data-vv-scope="step-3">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input
              v-model="SubmitButtonText"
              class="w-full mt-5"
              name="submit_button_text"
              v-validate="'required|alpha_spaces'" placeholder="Default"
            />
            <p><label class="mr-3">Submit</label> <vs-button color="rgb(76, 139, 246)" type="filled" class="mt-3">Submit</vs-button></p>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="demo-alignment">
              <span>Allow Multiple Submission</span>
              <div class="flex">
                <vs-switch v-model="switch1" />
              </div>
            </div>
            <div class="demo-alignment mt-4">
              <span>Allow Edit</span>
              <div class="flex">
                <vs-switch v-model="switch2" />
              </div>
            </div>
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input
              label="On Submit send mail to"
              v-model="SurveyRecipient"
              class="w-full mt-5"
              name="survey_recipient"
            />
          </div>
          <div class="vx-col w-full mt-5">
            
          </div>
        </div>
      </form>
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "q-form-builder/dist/css/app.6f06bd74.css";
import QFormBuilder from "./QFormBuilder";
import vSelect from 'vue-select';
// For custom error message
import { Validator } from "vee-validate";
const dict = {
  custom: {
    form_name: {
      required: "Form name is required",
      alpha: "Form name may only contain alphabetic characters"
    },
    last_name: {
      required: "Last name is required",
      alpha: "Last name may only contain alphabetic characters"
    },
    email: {
      required: "Email is required",
      email: "Please enter valid email"
    },
    job_title: {
      required: "Job title name is required",
      alpha: "Job title may only contain alphabetic characters"
    },
    proposal_title: {
      required: "Proposal title name is required",
      alpha: "Proposal title may only contain alphabetic characters"
    },
    event_name: {
      required: "Event name is required",
      alpha: "Event name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);
var vm;
import {
  TextElement,
  ParagraphElement,
  CheckboxesElement,
  RadioElement,
  DateElement,
  TimeElement,
  DropdownElement,
  EmailElement,
  NameElement,
  SimpleNameElement,
  AddressElement,
  PhoneElement,
  FileElement,
  PaymentElement,
  TermsElement,
  PageBreakElement,
  SectionBreakElement
} from "./index";

export default {
  name: "SampleApp",
  data() {
    return {
      sessionOptions: [
        { text: "Session 1", value: "1" },
        { text: "Session 2", value: "2" },
        { text: "Session 3", value: "3" },
        { text: "Session 4", value: "4" }
      ],
      radios1: '3',
      selected: ['Attendee'],
      options: ['Attendee','Speaker','Exhibitor', 'Sponsor'],
      switch1:true,
      switch2:true,
      //
      fields: [],
      fieldData: [],
      //FormId: "SF_TEST",
      FormId: "SurveyForm",
      FormType: 0,
      FormName: "",
      Session: "",
      SubmitButtonText: "",
      AllowUserReSubmit: false,
      SurveyRecipient: [],
      FormTypes: [
        { value: 1, label: "Poll" },
        { value: 2, label: "Survey" },
        { value: 3, label: "Form" }
      ],
      mySourceFields: [
        { type: "text", icon: "text_format", label: "Text" },
        { type: "paragraph", icon: "text_fields", label: "Paragraph" },
        { type: "checkboxes", icon: "check_box", label: "Checkboxes" },
        { type: "radio", icon: "radio_button_checked", label: "Mult. Choice" },
        { type: "date", icon: "event", label: "Date" },
        { type: "time", icon: "access_time", label: "Time" },
        { type: "dropdown", icon: "arrow_drop_down", label: "Dropdown" },
        { type: "email", icon: "email", label: "Email" },
        //{ type: "name", icon: "person", label: "Name" },
        //{ type: "simple_name", icon: "person_outline", label: "Simple Name" },
        //{ type: "address", icon: "home", label: "Address" },
        { type: "phone", icon: "phone", label: "Phone" }
        //{ type: "file", icon: "cloud_upload", label: "File Upload" },
        //{ type: "payment", icon: "payment", label: "Payment" },
        //{ type: "terms", icon: "ballot", label: "Terms" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "section_break", icon: "view_agenda", label: "Section Break" },
        //{ type: "page_break", icon: "call_to_action", label: "Page Break" }
      ],
      popupActive: false,
    };
  },
  methods: {
    /**
     * When a value is input into the rendered form, echo it to the debug line
     */
    onInput(val, id) {
      // console.debug(`${id}: ` + JSON.stringify(val))
    },
    /**
     * Determine the name of the Element object based on the 'field_type' of the field data object
     */
    getElement(field) {
      const nameParts = field.field_type.split("_");
      for (let i = 0; i < nameParts.length; i++) {
        nameParts[i] =
          nameParts[i].charAt(0).toUpperCase() + nameParts[i].slice(1);
      }
      return nameParts.join("") + "Element";
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then(result => {
          if (result) {
            alert("Form submitted!");
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    }
  },
  components: {
    FormWizard,
    TabContent,
    QFormBuilder,
    TextElement,
    ParagraphElement,
    CheckboxesElement,
    RadioElement,
    DateElement,
    TimeElement,
    DropdownElement,
    EmailElement,
    NameElement,
    SimpleNameElement,
    AddressElement,
    PhoneElement,
    FileElement,
    PaymentElement,
    TermsElement,
    PageBreakElement,
    SectionBreakElement,
    'v-select': vSelect,
  }
};
</script>


<style lang="scss">
.fullscreen.q-drawer__backdrop {
  display: none !important;
}
.editable-element-action-buttons {
  display: flex;
  z-index: 99;
}
.source-field {
  width: 120px;
}
.q-drawer{
  transform: translateX(0) !important;
}
body:not(.q-body--layout-animate) .q-layout--prevent-focus {
    visibility: visible !important;
}
/*.q-form-paragraph textarea {
  display: none;
}
.q-form-paragraph .q-textarea {
  display: none;
}*/
.button-wrap{display: flex; justify-content: flex-end; align-items: center; margin-bottom: 25px;}
.q-drawer {background: transparent;}
.q-tab-panels {background: transparent;}
.info-ico{width: 24px; height: 24px; display: inline-flex; justify-content: center; align-items: center; border: 2px solid #333; color: #333; font-weight: 600; font-size: 16px; border-radius: 50%; }
.source-field {width: 129px;}
button.q-btn.q-btn-item.non-selectable.no-outline.btn-fixed-width.q-btn--standard.q-btn--rectangle.q-btn--actionable.q-focusable.q-hoverable.q-btn--wrap.q-btn--dense {
    padding: 6px 0;
}
.q-page {padding: 20px; border: 1px solid #dfdfdf; border-left: 0; border-bottom: 0;}
.demo-alignment {text-align: right; display: flex; justify-content: flex-end; align-items: flex-start;}
.demo-alignment > * {margin-top: 0rem;}
</style>